export const CHANGE_CATEGORY = "CHANGE_CATEGORY"
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS"  


export const GET_MOVIES_SUCCESS = "GET_MOVIES_SUCCESS"


export const GET_CHOOSEN_MOVİE = "GET_CHOOSEN_MOVİE"  
export const GET_CHOOSEN_MOVIE_SUCCESS = "GET_CHOOSEN_MOVIE_SUCCESS"  

export const GET_TOP_MOVIES = "GET_TOP_MOVIES";
export const GET_TOP_MOVIES_SUCCESS = "GET_TOP_MOVIES_SUCCESS"  

export const GET_CATEGORIZED_MOVIES_SUCCESS = "GET_CATEGORIZED_MOVIES_SUCCESS";

export const GET_SIMILAR_MOVIES = "GET_SIMILAR_MOVIES";